import * as React from "react";
import { SVGProps } from "react";
function SvgJiraIconGray(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.006 4H15.45a5.21 5.21 0 0 0 5.212 5.211h2.125v2.058A5.21 5.21 0 0 0 28 16.48V4.994A.995.995 0 0 0 27.006 4Z"
        fill="#7A869A"
      />
      <path
        d="M21.28 9.76H9.726a5.21 5.21 0 0 0 5.211 5.211h2.126v2.058a5.21 5.21 0 0 0 5.211 5.211V10.754a.995.995 0 0 0-.994-.994Z"
        fill="url(#JiraIconGray_svg__a)"
      />
      <path
        d="M15.554 15.52H4a5.21 5.21 0 0 0 5.211 5.211h2.126v2.057A5.21 5.21 0 0 0 16.55 28V16.514a.995.995 0 0 0-.995-.994Z"
        fill="url(#JiraIconGray_svg__b)"
      />
      <defs>
        <linearGradient
          id="JiraIconGray_svg__a"
          x1={22.037}
          y1={9.773}
          x2={17.12}
          y2={14.842}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.176} stopColor="#344563" />
          <stop offset={1} stopColor="#7A869A" />
        </linearGradient>
        <linearGradient
          id="JiraIconGray_svg__b"
          x1={16.643}
          y1={15.564}
          x2={10.959}
          y2={21.094}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.176} stopColor="#344563" />
          <stop offset={1} stopColor="#7A869A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export default SvgJiraIconGray;
